import { render } from "./BlockerFunctionIndex.vue?vue&type=template&id=051d2292"
import script from "./BlockerFunctionIndex.vue?vue&type=script&lang=js"
export * from "./BlockerFunctionIndex.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__